import { ROUTES } from "constants/routes";

export const memberOptionLabel = (member, formatMessage) => {
  if (!member) return "";

  return [
    member.name || formatMessage({ id: "members.lifecycle.unnamed" }),
    member.document_number
      ? formatMessage({ id: "members.lifecycle.document" }, { value: member.document_number })
      : null,
    member.member_number
      ? formatMessage({ id: "members.lifecycle.memberNumber" }, { value: member.member_number })
      : null,
    member.is_active === false ? formatMessage({ id: "members.lifecycle.inactive" }) : null,
  ]
    .filter(Boolean)
    .join(" · ");
};

export const buildManualPointsUrl = (group, memberId) => {
  const classificationUuid = group?.classification?.uuid;
  if (!classificationUuid) return null;

  const params = new URLSearchParams({
    view: "manual-points",
    member_id: String(memberId),
  });

  if (group?.season?.id) {
    params.set("classification_season_id", String(group.season.id));
  }

  return `${ROUTES.ADMIN.ORGANIZATIONS}/classifications/${classificationUuid}?${params.toString()}`;
};

export const historySummaryItems = (history = {}) =>
  [
    ["ranking_rows", "members.lifecycle.history.rankingRows"],
    ["classification_events", "members.lifecycle.history.classificationEvents"],
    ["tournament_memberships", "members.lifecycle.history.tournamentMemberships"],
    ["tournament_entries", "members.lifecycle.history.tournamentEntries"],
    ["linked_players", "members.lifecycle.history.linkedPlayers"],
  ]
    .map(([key, messageId]) => ({ key, messageId, count: Number(history[key] || 0) }))
    .filter((item) => item.count > 0);
